<template>
  <div>
    <StoryblokComponent :blok="story.content" />

    <div
      v-if="featuredProducts"
      class="container container--inline container--small container--no-padding-top">
      <h4 class="h2 h-margin-top-xl h-margin-bottom-xl h-align-center">
        You want this
      </h4>
      <div :class="$style['featured']">
        <ProductCard v-for="(product, n) in featuredProducts" :key="'featured' + n" :to="getProductRoute({ product, lang: $lang})" :product="product" />
      </div>
    </div>
  </div>
</template>
<script setup>
import { useGutsStoryblok } from '~/composables/useGutsStoryblok'
import getProductRoute from '~/helpers/get-product-route'

await useI18n(['home'])
const { story, loadById, loadByParams } = useGutsStoryblok('homepage')
const { $api } = useNuxtApp()
const route = useRoute()
const featuredProducts = ref(null)

if (route.query?._storyblok) {
  await loadById(route.query?._storyblok, { version: 'draft' })
} else {
  await loadByParams({
    starts_with: 'homepage'
  })
}

onMounted(async () => {
  await nextTick()
  try {
    const data = await $api('staticpages/main')
    if (data) {
      featuredProducts.value = data.values.products_featured
    }
  } catch (e) {
    featuredProducts.value = false
  }
})

</script>
<style lang="scss" module>
.featured {
  display: grid;
  grid-template-columns: repeat(4,1fr);
  grid-gap: $spacing * 3;

  @media (max-width: #{$breakpoint-small-desktop}) {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
